import DataGridTableSkeleton from "../../../components/skeletons/DataGridTableSkeleton";

export default function OnboardingListSkeleton() {
  return (
    <DataGridTableSkeleton height={500} rowCount={10} />
  );
}
